import { render, staticRenderFns } from "./CleaningTaskEdit.vue?vue&type=template&id=4b9b8ab7&"
import script from "./CleaningTaskEdit.vue?vue&type=script&lang=js&"
export * from "./CleaningTaskEdit.vue?vue&type=script&lang=js&"
import style0 from "./CleaningTaskEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports